module.exports = __webpack_public_path__ + "img/osda.b458c6de.png";